import styles from './styles.module.scss';
import DiseasesIcon from '../../assets/icons/png/potential-diseases.png';
import { AiAnalyticsIcon } from './index.jsx';

const AiAnalyticsMessage = ({ t, diseaseAI }) => {
  return (
    <div className={`${styles.aiAnalyticsMessage}`}>
      {DiseasesIcon && <img src={DiseasesIcon} alt={t('sensor.diseasesTitle')} width="20" height="20" />}
      <div className={styles.aiAnalyticsMessageHeader}>
        <p className={styles.aiAnalyticsMessageTitle}>{t('sensor.diseasesTitle')}</p>
        <div className={`${styles.aiAnalyticsSubtitle}`}>
          {diseaseAI.confidence}% {t('sensor.probability')}
          <AiAnalyticsIcon />
        </div>
      </div>
      <div>
        {diseaseAI.name}. {diseaseAI.description}
      </div>
    </div>
  );
};

export default AiAnalyticsMessage;
